module.exports = __webpack_public_path__ + "static/media/addon.96672427.svg";